export default "__VITE_ASSET__3f32f3dc__"